module.exports = __webpack_public_path__ + "static/media/CGSE_Hero_England-Oxford.957d752a.jpg";